<template>
    <div class="warp">
        <div class="echarts" ref="echarts"></div>
    </div>
</template>
<script>
import echarts from 'echarts'
export default {
    name: 'echartsLine',
    props: ['echartsLineData'],
    data() {
        return {
            shopVisitClientYdata: [5, 7, 8, 10, 15, 19, 17, 18, 14, 12, 6, 5],
            shopConentViewYdata: [3, 5, 6, 9, 12, 16, 15, 11, 8, 5, 3, 1],
            goodsVisitClientYdata: [2, 4, 5, 8, 11, 15, 14, 10, 7, 4, 4, 2],
            goodsConentViewYdata: [13, 15, 16, 19, 22, 26, 25, 21, 18, 15, 13, 11],
            xdisplaydata: []
        }
    },
    watch: {
        echartsLineData(newVal, oldVal) {
            if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                return
            }
            this.$nextTick(() => {
                this.initChart(this.echartsLineData)
            })
        }
    },
    beforeDestroy() {
        if (!this.chart) {
            return
        }
        this.chart.dispose()
        this.chart = null
    },
    mounted() {},
    methods: {
        initChart(Edata) {
            this.xdisplaydata = Edata[0].xdisplaydata
            this.shopVisitClientYdata = Edata[1].shopVisitClientYdata
            this.shopConentViewYdata = Edata[2].shopConentViewYdata
            this.goodsVisitClientYdata = Edata[3].goodsVisitClientYdata
            this.goodsConentViewYdata = Edata[4].goodsConentViewYdata
            this.chart = echarts.init(this.$refs.echarts)
            this.chart.setOption(this.getOption())
        },
        getOption: function() {
            return {
                color: ['#409EFF', '#67C23A', '#E6A23C', '#F56C6C'],
                title: {
                    subtext: '近期趋势',
                    left: 'left',
                    subtextStyle: {
                        color: '#606266'
                    }
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['店铺访客数(UV)', '店铺访客数(PV)', '商品访客数', '商品访问量'],
                    icon: 'circle',
                    itemWidth: 10, // 设置宽度
                    itemHeight: 10 // 设置高度
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            show: false
                        }
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        lineStyle: {
                            color: '#ccc'
                        }
                    },
                    axisLabel: {
                        color: '#545454' // 刻度线标签颜色
                    },
                    data: this.xdisplaydata
                },
                yAxis: {
                    type: 'value',
                    name: '',
                    // nameTextStyle: {
                    //     color: 'red'
                    // },
                    axisLabel: {
                        color: '#545454' // 刻度线标签颜色
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#ccc'
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: ['#f2f2f2'],
                            type: 'dashed'
                        }
                    }
                },
                series: [
                    {
                        name: '店铺访客数(UV)',
                        type: 'line',
                        data: this.shopVisitClientYdata
                    },
                    {
                        name: '店铺访客数(PV)',
                        type: 'line',
                        data: this.shopConentViewYdata
                    },
                    {
                        name: '商品访客数',
                        type: 'line',
                        data: this.goodsVisitClientYdata
                    },
                    {
                        name: '商品访问量',
                        type: 'line',
                        data: this.goodsConentViewYdata
                    }
                ]
            }
        }
    }
}
</script>
<style scoped>
.warp {
    width: 100%;
    height: 100%;
}
.echarts {
    width: 100%;
    height: 100%;
}
</style>